module.exports = __webpack_public_path__ + "img/menu.9fd1d162.svg";